import { Component, EventEmitter, Input, Output } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import {
    PerCoverRow,
    OrderDetailsData,
} from '@app/domain/BookingDocket'

@Component({
    selector: 'app-order-details-modal',
    templateUrl: './order-details-modal.component.html',
})
export class OrderDetailsModalComponent {
    @Input() data!: OrderDetailsData
    @Output() printRequested = new EventEmitter<void>()

    constructor(public activeModal: NgbActiveModal) {}

    getSelectionsForCourse(row: PerCoverRow, courseName: string): string[] {
        return row.selectionsByCourse.get(courseName) || []
    }

    onPrint() {
        this.printRequested.emit()
    }

    close() {
        this.activeModal.dismiss()
    }
}
